/**
 * REACT_APP_KB_CONFLICT_CHECK_ENABLED — build-time switch for the KB editor's
 * "Check for conflicts" button and its findings drawer
 * (kb-conflict-check-drawer.tsx). Same pattern as ai-chat-flag.ts: default
 * OFF; absent/empty/anything but a truthy string means the button does not
 * render and no conflict-check request is ever made from this deployment.
 *
 * The server side has its own flag (pomsafe-services' KB_CONFLICT_CHECK_ENABLED);
 * when that one is off, pom-2-api answers SUPPORT_AGENT_CONFLICT_CHECK_DISABLED
 * and the drawer says so. This flag only decides whether the UI exists.
 *
 * Read at call time so tests can toggle it between cases (CRA inlines
 * `process.env.REACT_APP_*` at build time, which works inside a function too).
 *
 * Try it locally:
 *   REACT_APP_KB_CONFLICT_CHECK_ENABLED=true npm start
 */
const TRUTHY_VALUES = new Set(['true', '1', 'yes', 'on']);

export function isKbConflictCheckEnabled(): boolean {
  const raw = process.env.REACT_APP_KB_CONFLICT_CHECK_ENABLED;
  return typeof raw === 'string' && TRUTHY_VALUES.has(raw.trim().toLowerCase());
}
